function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_8262",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 8262",
  transform: "translate(277.059 160.252)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25594",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25594",
  d: "M-276.17-155.668h23.208v14.151l-12.3-4.892h-11.1S-276-155.5-276.17-155.668Z",
  fill: "none",
  stroke: "#3d5567",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25595",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25595",
  d: "M-272.887-155.406v-3.431h7.358v3.288",
  transform: "translate(0 -0.714)",
  fill: "none",
  stroke: "#3d5567",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25596",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25596",
  d: "M-273-145.592v9.649l2.943,3.963v11.973a2.718,2.718,0,0,0,2.717,2.717h0a2.717,2.717,0,0,0,2.717-2.717v-24",
  fill: "none",
  stroke: "#3d5567",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25597",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25597",
  d: "M-269.943-145.592v5.208L-267-135.63v9.17",
  transform: "translate(-1 3)",
  fill: "none",
  stroke: "#3d5567",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4
}), /*#__PURE__*/React.createElement("circle", {
  id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_5915",
  "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 5915",
  cx: 2.434,
  cy: 2.434,
  r: 2.434,
  transform: "translate(-261.34 -153.63)",
  fill: "none",
  stroke: "#3d5567",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4
}), /*#__PURE__*/React.createElement("circle", {
  id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_5916",
  "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 5916",
  cx: 1.132,
  cy: 1.132,
  r: 1.132,
  transform: "translate(-272.547 -152.498)",
  fill: "none",
  stroke: "#3d5567",
  strokeWidth: 1.4
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25598",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25598",
  d: "M-289.075-147.837h6.226v-9.432l-1.007-.54a5.167,5.167,0,0,0-4.251.019l-.855.379Z",
  transform: "translate(43)",
  fill: "none",
  stroke: "#3d5567",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25599",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25599",
  d: "M-287.377-149.215V-129.2h2.491v-20.019",
  transform: "translate(43 1.378)",
  fill: "none",
  stroke: "#3d5567",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25600",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25600",
  d: "M-288.962-130.309h-4.3v12.075l.181.132a11.811,11.811,0,0,0,13.743.095h0v-12.416h-3.849",
  transform: "translate(43)",
  fill: "none",
  stroke: "#3d5567",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4
}));

var SvgAxeAndShovel = function SvgAxeAndShovel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.419,
    height: 45.102,
    viewBox: "0 0 41.419 45.102",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAxeAndShovel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/axe-and-shovel.8b6c30d7.svg";
export { ForwardRef as ReactComponent };